import React, { useState } from 'react';
import DynamicDetailsModal from '@nexus/fff-ui-shared/DynamicDetailsModal';
import ButtonLink from '@nexus/fff-ui-shared/ButtonLink';
import { SUBSCRIBE_AND_SAVE_LIST_DATA } from 'utils/subscriptions';

import styles from './SubscribeAndSaveDetails.module.css';

const SubscribeAndSaveDetails = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleFunction = () => setIsOpen((prevState) => !prevState);

  return (
    <div className={styles.wrapper}>
      <strong>Subscribe & Save</strong> Ships every 3 months
      <ButtonLink
        type="black"
        label="Learn More"
        onClick={toggleFunction}
        bold
      />
      <DynamicDetailsModal
        title="Subscribe & Save"
        isOpen={isOpen}
        toggleFunction={toggleFunction}
        imageURI="https://scontent01.fabfitfun.com/ecom/images/2023/7/aquarius.png"
        subtitle="How it works"
        detail="Subscribe & save up to 75% off. Get your favorite brands and products delivered every 3 months. Cancel anytime."
        list={SUBSCRIBE_AND_SAVE_LIST_DATA}
      />
    </div>
  );
};

export default SubscribeAndSaveDetails;
